import { Component, Input, OnInit } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Toast } from 'ngx-toastr';
import { NotificationsService } from '@services/notifications/notifications.service';
import { BlobServiceClient } from '@azure/storage-blob';
import { IBlobStorageSettings } from '@models/azure-storage-settings/azure-storage-setting';
import { Globals } from '@models/globals';
import { GlobalParamsService } from '@services/global-params/global-params.service';
import { CustomerConfigurationService } from '@services/customer-configuration/customer-configuration';
import { forkJoin } from 'rxjs';
import { ToastLevel } from '@shared/toasterSetup';

@Component({
  selector: 'app-user-manuals-download',
  templateUrl: './user-manuals-download.component.html',
  styleUrls: ['./user-manuals-download.component.scss'],
  standalone: true,
  imports: [MatTooltipModule]
})
export class UserManualsDownloadComponent implements OnInit {
  private blob: BlobServiceClient;
  private blobUrl: string;
  private config: IBlobStorageSettings;
  private blobSas: string;

  @Input() public downloadItem: any;

  constructor(
    private readonly notificationService: NotificationsService,
    private readonly globalParamsService: GlobalParamsService,
    private readonly customerConfigurationService: CustomerConfigurationService,
  ) {}

  public ngOnInit(): void {
    // Only load the configuration, don't download automatically
    this.loadConfiguration();
  }

  private loadConfiguration(): void {
    if (!this.config) {
      this.customerConfigurationService.getBlobStorageSettings().subscribe(
        blobSettings => {
          this.config = blobSettings;
        },
        err => {
          console.error(err);
          const errorToast: Toast = {
            title: `Error loading settings`,
            message: ''          
          } as Toast;
          this.notificationService.showToast(ToastLevel.Error, errorToast);
        }
      );
    }
  }

  public downloadUserManuals(): void {
    if (!this.config) {
      this.loadConfiguration();
      const errorToast: Toast = {
        title: `Please wait while settings are loading`,
        message: 'Try again in a moment'          
      } as Toast;
      this.notificationService.showToast(ToastLevel.Warning, errorToast);
      return;
    }

    try {
      this.blobSas = this.config.SAS;
      this.blobUrl = this.config.Url;
      this.blob = new BlobServiceClient(`${this.blobUrl}?${this.blobSas}`);
      const manualContainer = this.config.Container;
      const containerClient = this.blob.getContainerClient(manualContainer);
      const blockBlobClient = containerClient.getBlockBlobClient('Empyrean Liquidity User Guide 2507.pdf');
      window.open(blockBlobClient.url);
    } catch (err) {
      console.error(err);
      const errorToast: Toast = {
        title: `Error downloading User Manual`,        
        message: ''
      } as Toast;
      this.notificationService.showToast(ToastLevel.Error, errorToast);
    } finally {
      Globals.importUpload = false;
    }
  }
}
